(() => {
  const section = document.querySelector('.main-product[data-product-section]');
  if (!section) return;

  const parameters = new URL(window.location.href).searchParams;
  const hasExplicitVariant = parameters.has('variant');

  if (!hasExplicitVariant) {
    section.querySelectorAll('[data-product-option]').forEach((input) => {
      input.checked = false;
    });

    section.querySelectorAll('[data-option-current]').forEach((current) => {
      current.textContent = 'auswählen';
    });

    const submit = section.querySelector('[data-product-submit]');
    const submitLabel = section.querySelector('[data-product-submit-label]');
    const stickySubmit = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-add-label]');
    if (submit) submit.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Farbe auswählen';
    if (stickySubmit) stickySubmit.disabled = true;
    if (stickyLabel) stickyLabel.textContent = 'Farbe auswählen';

    const gallery = section.querySelector('[data-product-gallery]');
    const primaryImage = gallery?.querySelector('[data-gallery-slide] img');
    const defaultImageUrl = document.querySelector('meta[property="og:image"]')?.content || '';
    if (primaryImage && defaultImageUrl) {
      primaryImage.src = defaultImageUrl;
      primaryImage.removeAttribute('srcset');
      primaryImage.removeAttribute('sizes');
      primaryImage.alt = `${section.querySelector('.product-title--brand')?.textContent?.trim() || 'KABO PackSmart'} – Produktansicht`;
    }
    if (gallery) {
      gallery.scrollLeft = 0;
      gallery.removeAttribute('data-active-media-id');
    }
  }

  if (window.matchMedia('(max-width: 749px)').matches) {
    section.querySelectorAll('[data-gallery-overflow]').forEach((slide) => {
      slide.hidden = false;
      slide.removeAttribute('data-gallery-overflow');
    });
    section.querySelectorAll('[data-gallery-expand]').forEach((button) => button.remove());
  }
})();
